import { render, staticRenderFns } from "./UserRights.vue?vue&type=template&id=fc6543a0&scoped=true"
import script from "./UserRights.vue?vue&type=script&lang=js"
export * from "./UserRights.vue?vue&type=script&lang=js"
import style0 from "./UserRights.vue?vue&type=style&index=0&id=fc6543a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6543a0",
  null
  
)

export default component.exports